import { ReceiveTransferDetailResponse } from "../../../common/api/Models/ReceiveTransferDetailResponse";
import {useAxiosGet} from "../../../infrastructure/http";

export function useGetReceiveTransferDetails(transferId: string, receiveId: string, includeComments?: boolean, manual?: boolean) {
    let query: string[] = [];
    if (transferId) query.push("transferId=" + transferId);
    if (receiveId) query.push("receiveId=" + receiveId);
    if (includeComments) query.push("includeComments=true");
    let queryString = query.join("&");

    return useAxiosGet<ReceiveTransferDetailResponse>(`/ReceiveTransferDetails${(queryString ? "?" + queryString : "")}`, manual ?? false);
}